import React from 'react';

function NavItem({ icon, label, active, onClick }) {
  return (
    <button
      type="button"
      className={active ? 'bottom-nav-item bottom-nav-item-active' : 'bottom-nav-item'}
      onClick={onClick}
      aria-label={label}
    >
      <span className="bottom-nav-icon" aria-hidden="true">
        {icon}
      </span>
      <span className="sr-only">{label}</span>
    </button>
  );
}

export default NavItem;
